import styled, { css } from 'styled-components';
import breakpoints from 'theme/breakpoints';
import colors from 'theme/colors';

// Paleta oficial da campanha #3anosdewhizr (extraída do material de marca
// fornecido pelo time de marketing) — escopo local a esta landing, não faz
// parte do design system global.
export const campaign = {
    purple: colors.occasionalPurple, // #690ce4 — mesma cor do brand principal
    purpleDeep: '#2e0578',
    magenta: '#cd11e8', // cor oficial "produtores" no material da campanha
    magentaDark: '#9c0eb5',
    pink: '#ef1556', // cor oficial "estabelecimentos", usada só de leve aqui
    blue: '#a0ddff',
    gold: '#ffc13a',
};

export const Section = styled.section`
    width: 100%;
    padding: 64px 20px;
    position: relative;
    overflow: hidden;

    @media screen and (min-width: ${breakpoints.smd}) {
        padding: 88px 32px;
    }
`;

export const SectionInner = styled.div`
    max-width: 1080px;
    margin: 0 auto;
    position: relative;
    z-index: 1;
`;

export const Eyebrow = styled.div`
    display: inline-flex;
    align-items: center;
    gap: 6px;
    padding: 6px 14px;
    border-radius: 50px;
    background: ${({ $onDark }) => $onDark ? 'rgba(255,255,255,0.14)' : `${campaign.purple}14`};
    color: ${({ $onDark }) => $onDark ? '#fff' : campaign.purple};
    font-size: 13px;
    font-weight: 700;
    letter-spacing: 0.02em;
    margin-bottom: 18px;
`;

export const SectionTitle = styled.h2`
    font-size: 28px;
    line-height: 1.2;
    font-weight: 800;
    color: ${({ $onDark }) => $onDark ? '#fff' : colors.nightDark};
    margin: 0 0 16px;
    letter-spacing: -0.01em;

    @media screen and (min-width: ${breakpoints.smd}) {
        font-size: 38px;
    }
`;

export const SectionSubtitle = styled.p`
    font-size: 16px;
    line-height: 1.55;
    color: ${({ $onDark }) => $onDark ? 'rgba(255,255,255,0.82)' : colors.night};
    margin: 0 0 28px;
    max-width: 620px;

    @media screen and (min-width: ${breakpoints.smd}) {
        font-size: 18px;
    }
`;

const buttonBase = css`
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    border: none;
    cursor: pointer;
    border-radius: 50px;
    font-weight: 700;
    font-size: 15px;
    padding: 15px 28px;
    transition: transform 0.15s ease, box-shadow 0.15s ease, opacity 0.15s ease;
    white-space: nowrap;

    &:hover {
        transform: translateY(-1px);
    }

    &:active {
        transform: translateY(0);
    }
`;

export const PrimaryButton = styled.button`
    ${buttonBase}
    background: ${campaign.magenta};
    color: #fff;
    box-shadow: 0 8px 24px ${campaign.magenta}55;

    &:hover {
        background: ${campaign.magentaDark};
        box-shadow: 0 10px 28px ${campaign.magenta}66;
    }
`;

export const GhostButton = styled.button`
    ${buttonBase}
    background: transparent;
    color: ${({ $onDark }) => $onDark ? '#fff' : colors.nightDark};
    border: 1.5px solid ${({ $onDark }) => $onDark ? 'rgba(255,255,255,0.5)' : `${colors.night}44`};

    &:hover {
        background: ${({ $onDark }) => $onDark ? 'rgba(255,255,255,0.1)' : colors.neutralDark};
    }
`;

export const CountdownChip = styled.div`
    display: inline-flex;
    align-items: center;
    gap: 8px;
    padding: 9px 16px;
    border-radius: 50px;
    background: ${({ $onDark }) => $onDark ? 'rgba(255,255,255,0.14)' : `${campaign.gold}22`};
    color: ${({ $onDark }) => $onDark ? '#fff' : '#8a5a00'};
    font-size: 13px;
    font-weight: 700;

    strong {
        font-size: 15px;
    }
`;

export const BlobImg = styled.img`
    position: absolute;
    pointer-events: none;
    user-select: none;
    z-index: 0;
`;

export const FeatureGrid = styled.div`
    display: grid;
    grid-template-columns: 1fr;
    gap: 20px;
    margin-top: 36px;

    @media screen and (min-width: ${breakpoints.smd}) {
        grid-template-columns: repeat(3, 1fr);
    }
`;

export const FeatureCard = styled.div`
    background: ${({ $onDark }) => $onDark ? 'rgba(255,255,255,0.08)' : '#fff'};
    border: 1px solid ${({ $onDark }) => $onDark ? 'rgba(255,255,255,0.14)' : `${colors.night}1a`};
    border-radius: 18px;
    padding: 24px;
    backdrop-filter: ${({ $onDark }) => $onDark ? 'blur(6px)' : 'none'};
`;

export const FeatureIconBox = styled.div`
    width: 44px;
    height: 44px;
    border-radius: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: ${({ $onDark }) => $onDark ? 'rgba(255,255,255,0.14)' : `${campaign.purple}14`};
    color: ${({ $onDark }) => $onDark ? '#fff' : campaign.purple};
    margin-bottom: 14px;
`;

export const FeatureTitle = styled.h3`
    font-size: 17px;
    font-weight: 700;
    color: ${({ $onDark }) => $onDark ? '#fff' : colors.nightDark};
    margin: 0 0 8px;
`;

export const FeatureText = styled.p`
    font-size: 14.5px;
    line-height: 1.5;
    color: ${({ $onDark }) => $onDark ? 'rgba(255,255,255,0.78)' : colors.night};
    margin: 0;
`;
